<template>
    <div>
        <loading :active.sync="is_loading"
        :can-cancel="true"
        :is-full-page="true"></loading>
        <Navbar />
        <div class="container-fluid">
            <div class="sidebar">
                <SidebarWaterQuality />
            </div>
            <div id="main" class="main">
                <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '/index-kualitas-air', text: 'Index Kualitas Air'}]"/>
                <h2><b>{{ $route.params.location.toUpperCase() }}</b></h2>
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12 col-md-2">
                                <div class="form-group">Tahun</div>
                                <select class="form-select" v-model="filter_tahun">
                                    <option v-for="(tahun, i) in yearRange()" :value="tahun" :key="i">{{ tahun }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-3">
                                <div class="form-group">Bulan</div>
                                <select class="form-select" v-model="filter_bulan">
                                    <option v-for="(bulan, i) in months" :value="(i + 1).toString().padStart(2, '0')" :key="i">{{ bulan }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label for="">&nbsp;</label><br>
                                    <button class="btn btn-primary" @click="getData(1)">
                                        <i class="fa fa-filter"></i> Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered">
                            <thead>
                                <tr class="tableizer-firstrow">
                                    <th colspan="6" class="text-center">Indeks Kualitas Air</th>
                                </tr>
                                <tr>
                                    <th>Mutu Air </th>
                                    <th>Jumlah Titik Pemantauan</th>
                                    <th>Persentase</th>
                                    <th>Bobot Nilai Indeks</th>
                                    <th>Nilai Indeks per Mutu Air</th>
                                    <th>Kategori</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Memenuhi</td>
                                    <td>{{ mutu_air.memenuhi }}</td>
                                    <td>{{ mutu_air.persen_memenuhi }}%</td>
                                    <td>70</td>
                                    <td>{{ mutu_air.index_memenuhi }}</td>
                                    <td rowspan="5" class="align-middle text-center">{{ mutu_air.kategori }}</td>
                                </tr>
                                <tr>
                                    <td>Cemar Ringan</td>
                                    <td>{{ mutu_air.cemar_ringan }}</td>
                                    <td>{{ mutu_air.persen_cemar_ringan }}%</td>
                                    <td>50</td>
                                    <td>{{ mutu_air.index_cemar_ringan }}</td>
                                </tr>
                                <tr>
                                    <td>Cemar Sedang</td>
                                    <td>{{ mutu_air.cemar_sedang }}</td>
                                    <td>{{ mutu_air.persen_cemar_sedang }}%</td>
                                    <td>30</td>
                                    <td>{{ mutu_air.index_cemar_sedang }}</td>
                                </tr>
                                <tr>
                                    <td>Cemar Berat</td>
                                    <td>{{ mutu_air.cemar_berat }}</td>
                                    <td>{{ mutu_air.persen_cemar_berat }}%</td>
                                    <td>10</td>
                                    <td>{{ mutu_air.index_cemar_berat }}</td>
                                </tr>
                                <tr>
                                    <td class="text-end"><b>Total</b></td>
                                    <td>{{ data.data.length }}</td>
                                    <td>&nbsp;</td>
                                    <td class="text-end"><b>IKA</b></td>
                                    <td><b>{{ mutu_air.index_total }}</b></td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th rowspan="2">Kode</th>
                                    <th rowspan="2">Sungai</th>
                                    <th rowspan="2">Lokasi</th>
                                    <th rowspan="2">pH</th>
                                    <th>TSS</th>
                                    <th>Nitrat</th>
                                    <th>DO</th>
                                    <th>BOD</th>
                                    <th>COD</th>
                                    <th>Total P</th>
                                    <th rowspan="2">Fecal Coli</th>
                                    <template v-if="$route.params.location === 'waduk'">
                                        <th>Klorofil-a</th>
                                        <th>Transparansi</th>
                                    </template>
                                    <th rowspan="2">Ci-Lix Rata-rata</th>
                                    <th rowspan="2">Ci-Lix Maks.</th>
                                    <th rowspan="2">Pix</th>
                                    <th rowspan="2">Indeks Pencemaran</th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-center">mg/L</th>
                                    <template v-if="$route.params.location === 'waduk'">
                                        <th>mg/m3</th>
                                        <th>m</th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="data.data.length === 0">
                                    <td colspan="15">Belum ada data</td>
                                </tr>
                                <template v-else>
                                    <tr v-for="row in data.data" :key="row.id">
                                        <td>{{ row.code }}</td>
                                        <td>{{ row.sungai }}</td>
                                        <td>{{ row.lokasi }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].ph:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].tss:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].nitrat:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].do:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].bod:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].cod:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].total_p:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].fecal_coli:'' }}</td>
                                        <template v-if="$route.params.location === 'waduk'">
                                            <td>{{ row.samplings.length > 0 ? row.samplings[0].klorofil_a:'' }}</td>
                                            <td>{{ row.samplings.length > 0 ? row.samplings[0].transparansi:'' }}</td>
                                        </template>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].ci_lix_avg:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].ci_lix_max:'' }}</td>
                                        <td>{{ row.samplings.length > 0 ? row.samplings[0].pix:'' }}</td>
                                        <td
                                            class="text-center"
                                            :style="indexCemarStyle(row.samplings.length > 0 ? row.samplings[0].pix:undefined)"
                                            v-html="indexCemar(row.samplings.length > 0 ? row.samplings[0].pix:undefined)"></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                <li v-for="page in data.meta.pageCount" class="page-item" :class="page === data.meta.currentPage ? 'active':''" :key="page">
                                    <a class="page-link" href="#" @click.prevent="() => getData(page)">{{ page }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import Breadcrumb from '../../components/Breadcrumb.vue'
import SidebarWaterQuality from '../../components/SidebarWaterQuality.vue'
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import Select2 from 'v-select2-component';
import _ from 'lodash';
import Datepicker from 'vuejs-datepicker'

export default
{
    components: {
        Navbar,
        Breadcrumb,
        SidebarWaterQuality,
        Loading,
        Datepicker,
        Select2
    },
    data(){
        return {
            is_loading: false,
            date: new Date(),
            months: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
            filter_tahun: new Date().getFullYear(),
            filter_bulan: ((new Date().getMonth() + 1).toString().padStart(2, '0')),
            memenuhi: 0,
            cemar_ringan: 0,
            cemar_sedang: 0,
            cemar_berat: 0,
            data: {
                data: [],
                meta: {}
            }
        }
    },
    mounted(){
        this.getData(1);
    },
    computed: {
        filter_bln(){
            return `${this.filter_tahun}-${this.filter_bulan}`
        },
        mutu_air(){
            let memenuhi = 0;
            let cemar_ringan = 0;
            let cemar_sedang = 0;
            let cemar_berat = 0;

            this.data.data.forEach(lokasi => {
                const sampling = lokasi.samplings.length > 0 ? lokasi.samplings[0]:null;
                if(sampling !== null){
                    if (sampling.pix <= 1) {
                        memenuhi += 1;
                    } else if (sampling.pix <= 5) {
                        cemar_ringan += 1;
                    } else if (sampling.pix <= 10) {
                        cemar_sedang += 1;
                    } else {
                        cemar_berat += 1;
                    }
                }
            });

            const index_memenuhi = (memenuhi / this.data.data.length * 70);
            const index_cemar_ringan = (cemar_ringan / this.data.data.length * 50);
            const index_cemar_sedang = (cemar_sedang / this.data.data.length * 30);
            const index_cemar_berat = (cemar_berat / this.data.data.length * 10);
            const index_total = index_memenuhi + index_cemar_ringan + index_cemar_sedang + index_cemar_berat;
            const kategori = (index_total < 25) ? "Sangat Kurang"
                            : (index_total < 50) ? "Kurang"
                            : (index_total < 70) ? "Sedang"
                            : (index_total < 90) ? "Baik"
                            : "Sangat Baik";

            return {
                memenuhi,
                cemar_ringan,
                cemar_sedang,
                cemar_berat,
                persen_memenuhi: (memenuhi / this.data.data.length * 100),
                persen_cemar_ringan: (cemar_ringan / this.data.data.length * 100),
                persen_cemar_sedang: (cemar_sedang / this.data.data.length * 100),
                persen_cemar_berat: (cemar_berat / this.data.data.length * 100),
                index_memenuhi,
                index_cemar_ringan,
                index_cemar_sedang,
                index_cemar_berat,
                index_total,
                kategori
            }
        }
    },
    methods: {
        async getData(page) {
            this.is_loading = true;

            try {
                const response = await axios.get(`${this.$endpoints.wq}/locations`, {
                    params: {
                        tipe: this.$route.params.location.toUpperCase(),
                        page,
                        filter_bln: this.filter_bln
                    }
                });

                this.data.data = response.data.data;
                this.data.meta = response.data.meta;
            } catch (error) {
                
            }

            this.is_loading = false;
        },
        yearRange(){
            const start = this.date.getFullYear() - 20;
            const end = this.date.getFullYear() + 1;

            return _.range(start, end)
        },
        indexCemar(pix){
            if(typeof pix === 'undefined') return '';
            
            if (pix <= 1) {
                return "Memenuhi";
            } else if (pix <= 5) {
                return "Cemar Ringan";
            } else if (pix <= 10) {
                return "Cemar Sedang";
            } else {
                return "Cemar Berat";
            }
        },
        indexCemarStyle(pix){
            if(typeof pix === 'undefined') return '';
            
            if (pix <= 1) {
                return "background: #28a745";
            } else if (pix <= 5) {
                return "background: ##ffc107";
            } else if (pix <= 10) {
                return "background: #753914; color: #fff";
            } else {
                return "background: #dc3545";
            }
        }
    }
}
</script>